"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PMTransactionTypeEnum = exports.UpdateTypeEnum = exports.AutoRenewEnum = exports.PurchaseTypeEnum = exports.RecurringPaymentStatusEnum = exports.SubscriptionCategoryEnum = exports.StripeSubscriptionStatusEnum = exports.SubscriptionsEventTypeEnum = exports.StripeEventTypeEnum = exports.PaymentTypeEnum = exports.PaymentStatusEnum = void 0;
var PaymentStatusEnum;
(function (PaymentStatusEnum) {
    PaymentStatusEnum[PaymentStatusEnum["Pending"] = 0] = "Pending";
    PaymentStatusEnum[PaymentStatusEnum["Approved"] = 1] = "Approved";
    PaymentStatusEnum[PaymentStatusEnum["Rejected"] = 2] = "Rejected";
})(PaymentStatusEnum = exports.PaymentStatusEnum || (exports.PaymentStatusEnum = {}));
var PaymentTypeEnum;
(function (PaymentTypeEnum) {
    PaymentTypeEnum[PaymentTypeEnum["ManualBankTransfer"] = 0] = "ManualBankTransfer";
    PaymentTypeEnum[PaymentTypeEnum["PaymentGateway"] = 1] = "PaymentGateway";
    PaymentTypeEnum[PaymentTypeEnum["Wallet"] = 2] = "Wallet";
})(PaymentTypeEnum = exports.PaymentTypeEnum || (exports.PaymentTypeEnum = {}));
var StripeEventTypeEnum;
(function (StripeEventTypeEnum) {
    StripeEventTypeEnum[StripeEventTypeEnum["PaymentIntent"] = 0] = "PaymentIntent";
    StripeEventTypeEnum[StripeEventTypeEnum["Subscriptions"] = 1] = "Subscriptions";
})(StripeEventTypeEnum = exports.StripeEventTypeEnum || (exports.StripeEventTypeEnum = {}));
var SubscriptionsEventTypeEnum;
(function (SubscriptionsEventTypeEnum) {
    SubscriptionsEventTypeEnum[SubscriptionsEventTypeEnum["BillCreated"] = 0] = "BillCreated";
    SubscriptionsEventTypeEnum[SubscriptionsEventTypeEnum["BillCycle"] = 1] = "BillCycle";
    SubscriptionsEventTypeEnum[SubscriptionsEventTypeEnum["PaymentFailure"] = 2] = "PaymentFailure";
    SubscriptionsEventTypeEnum[SubscriptionsEventTypeEnum["DeleteSubscription"] = 3] = "DeleteSubscription";
    SubscriptionsEventTypeEnum[SubscriptionsEventTypeEnum["UpdateSubscription"] = 4] = "UpdateSubscription";
})(SubscriptionsEventTypeEnum = exports.SubscriptionsEventTypeEnum || (exports.SubscriptionsEventTypeEnum = {}));
var StripeSubscriptionStatusEnum;
(function (StripeSubscriptionStatusEnum) {
    StripeSubscriptionStatusEnum[StripeSubscriptionStatusEnum["Ongoing"] = 0] = "Ongoing";
    StripeSubscriptionStatusEnum[StripeSubscriptionStatusEnum["Closed"] = 1] = "Closed";
    StripeSubscriptionStatusEnum[StripeSubscriptionStatusEnum["PaymentSuccessful"] = 2] = "PaymentSuccessful";
    StripeSubscriptionStatusEnum[StripeSubscriptionStatusEnum["PaymentUnsuccessful"] = 3] = "PaymentUnsuccessful";
})(StripeSubscriptionStatusEnum = exports.StripeSubscriptionStatusEnum || (exports.StripeSubscriptionStatusEnum = {}));
var SubscriptionCategoryEnum;
(function (SubscriptionCategoryEnum) {
    SubscriptionCategoryEnum[SubscriptionCategoryEnum["PropertyManagement"] = 4] = "PropertyManagement";
    SubscriptionCategoryEnum[SubscriptionCategoryEnum["VacantManagement"] = 6] = "VacantManagement";
})(SubscriptionCategoryEnum = exports.SubscriptionCategoryEnum || (exports.SubscriptionCategoryEnum = {}));
var RecurringPaymentStatusEnum;
(function (RecurringPaymentStatusEnum) {
    RecurringPaymentStatusEnum[RecurringPaymentStatusEnum["Approved"] = 0] = "Approved";
    RecurringPaymentStatusEnum[RecurringPaymentStatusEnum["Rejected"] = 1] = "Rejected";
})(RecurringPaymentStatusEnum = exports.RecurringPaymentStatusEnum || (exports.RecurringPaymentStatusEnum = {}));
var PurchaseTypeEnum;
(function (PurchaseTypeEnum) {
    PurchaseTypeEnum[PurchaseTypeEnum["PurchasePackage"] = 0] = "PurchasePackage";
    PurchaseTypeEnum[PurchaseTypeEnum["WalletTopup"] = 1] = "WalletTopup";
    PurchaseTypeEnum[PurchaseTypeEnum["PropertyManagementTransaction"] = 2] = "PropertyManagementTransaction";
})(PurchaseTypeEnum = exports.PurchaseTypeEnum || (exports.PurchaseTypeEnum = {}));
var AutoRenewEnum;
(function (AutoRenewEnum) {
    AutoRenewEnum[AutoRenewEnum["True"] = 0] = "True";
    AutoRenewEnum[AutoRenewEnum["False"] = 1] = "False";
})(AutoRenewEnum = exports.AutoRenewEnum || (exports.AutoRenewEnum = {}));
var UpdateTypeEnum;
(function (UpdateTypeEnum) {
    UpdateTypeEnum[UpdateTypeEnum["Subscription"] = 0] = "Subscription";
    UpdateTypeEnum[UpdateTypeEnum["AutoRenew"] = 1] = "AutoRenew";
})(UpdateTypeEnum = exports.UpdateTypeEnum || (exports.UpdateTypeEnum = {}));
var PMTransactionTypeEnum;
(function (PMTransactionTypeEnum) {
    PMTransactionTypeEnum[PMTransactionTypeEnum["topup"] = 0] = "topup";
    PMTransactionTypeEnum[PMTransactionTypeEnum["transaction"] = 1] = "transaction";
    PMTransactionTypeEnum[PMTransactionTypeEnum["withdrawal"] = 2] = "withdrawal";
    PMTransactionTypeEnum[PMTransactionTypeEnum["rental"] = 3] = "rental";
})(PMTransactionTypeEnum = exports.PMTransactionTypeEnum || (exports.PMTransactionTypeEnum = {}));
